import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

/**
 * @file index.ts
 * @author markJia(markjia@tencent.com)
 */
import { DropdownLink } from '../../views/ViewDropdown/DropdownLink';
import { useDropdown } from '../../views/ViewDropdown/useDropdown';
export var Dropdown = function Dropdown(props) {
  var children = props.children,
      extra = _objectWithoutProperties(props, _excluded);

  return useDropdown(extra, children);
};
Dropdown.Link = DropdownLink;